import {InvoiceOrder, PurchaseOrder} from './invoice-order';
import {ServiceOrder} from './service-order';
import {Currency} from './currency';

export interface AnalyticOperation {
  id: number,
  serviceOrderId: number,
  projectId?: number,
  description: string,
  /** Detalle descriptivo libre de la operación; se imprime bajo su servicio en el PDF del EP/OC. */
  details?: string | null,
  class: string,
  type: string,
  isIndirect: boolean,
  amount: number,
  quantity: number,
  currencyId: number,
  repercussionId: number,
  invoiceOrderId: number,
  purchaseOrderId: number,
  isImputable: boolean
  invoiceOrder?: InvoiceOrder;
  purchaseOrder?: PurchaseOrder;
  referenceCEC?:string;
  unitPrice: number;
  applyVat?: boolean;
  vatPercentage?: number;
  taxType?: string;
  serviceOrder?: ServiceOrder;
  project?: {
    id: number;
    reference?: string | null;
    name?: string | null;
  } | null;
  container?: {
    id?: number;
    reference?: string | null;
    containerRef?: string | null;
    name?: string | null;
  } | null;
  services?: {
    id: number;
    reference?: string | null;
    name?: string | null;
    hasFlow?: boolean;
  }[];

  currency?: Currency;
  serviceOrderReference?: string;
  /** Contenedor de la OA; viene en respuestas de /core/api/AnalyticOperation y get/available-for-orders */
  serviceOrderContainer?: string | null;
}

export interface AnalyticOperationCreate {
  serviceOrderId: number,
  description: string,
  details?: string | null,
  class: string,
  type: string,
  isIndirect: boolean,
  currencyId: number,
  repercussionId: number,
  invoiceOrderId: number,
  purchaseOrderId: number,
  isImputable: boolean
  quantity: number,
  unitPrice: number;
  applyVat: boolean;
  vatPercentage: number;
  taxType: string;
}

export interface MoneyData {
  label: string;
  value: number;
  valueAlt: number;
  isPercentage: boolean;
}

export interface AnalyticOperationData {
  totalData: AnalyticOperationClassData;
  planData: AnalyticOperationClassData;
  executedData: AnalyticOperationClassData;
  engagedData: AnalyticOperationClassData;
}

export interface AnalyticOperationClassData {
  incomeTotal: number;
  expensesTotal: number;
  margin: number;
  percent: number;
}
